module.exports = __webpack_public_path__ + "assets/4b46cc4a8a5c5164dfca687ddc10f2e0.png";